import { useEffect, useState } from 'react'
import { Clock, X } from 'lucide-react'

export default function CartExpiryNotice() {
  const [showNotice, setShowNotice] = useState(false)
  const [daysLeft, setDaysLeft] = useState(7)

  useEffect(() => {
    // Check cart saved date from localStorage
    const cartData = localStorage.getItem('BotTola-cart')
    if (cartData) {
      try {
        const parsed = JSON.parse(cartData)
        const savedAt = parsed.state?.savedAt || new Date().getTime()
        const daysSince = (new Date().getTime() - savedAt) / (1000 * 60 * 60 * 24)
        const daysRemaining = Math.ceil(7 - daysSince)
        
        if (daysRemaining <= 3 && daysRemaining > 0 && parsed.state?.items?.length > 0) {
          setDaysLeft(daysRemaining)
          setShowNotice(true)
        }
      } catch (e) {
        // Ignore parsing errors
      }
    }
  }, [])

  if (!showNotice) return null

  return (
    <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex items-start gap-3">
        <Clock className="h-5 w-5 text-yellow-600 dark:text-yellow-500 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-medium text-yellow-800 dark:text-yellow-400 mb-1">
            Your cart will expire soon
          </h3>
          <p className="text-sm text-yellow-700 dark:text-yellow-500">
            Your saved items will be removed in {daysLeft} day{daysLeft !== 1 ? 's' : ''}. 
            Complete your checkout or create an account to save them permanently.
          </p>
        </div>
        <button
          onClick={() => setShowNotice(false)}
          className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-500 dark:hover:text-yellow-400"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}
